export default __webpack_public_path__ + "static/media/HIW_STEPS1.5d669fbb.svg";